module.exports = {
  schema: {
    name: '科目',
    type: 'Object',
    contents: {
      accountCode: {
        type: 'String',
        name: '科目代碼',
        unique: true,
      },
      account: {
        type: 'String',
        name: '科目',
      },
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'accountCode', width: 100 },
        { key: 'account', width: 130 },
      ],
    },
    editor: {
      config: { titleSm: 2, titleMd: 1 },
      groups: [
        {
          name: '科目',
          rows: [
            [{ key: 'accountCode' }],
            [{ key: 'account' }],
          ],
        },
      ],
    },
  },
}




// WEBPACK FOOTER //
// ./src/models/accounts.js